// Mock data for Westbay Group website

export const mockData = {
  company: {
    name: "Westbay Group",
    tagline: "Cloud & AI Safety Net",
    description: "Veteran-owned technology consulting, Fractional CTO services, cloud security, DevOps, and AI solutions that make complex stuff simple. We've got your back while you focus on growing your business."
  },
  
  services: [
    {
      id: 1,
      title: "Cloud Security",
      description: "Your cloud safety net. We protect your infrastructure so you can sleep soundly and focus on what matters—growing your business.",
      features: [
        "24/7 Threat Monitoring",
        "Smart Access Controls",
        "Security Health Checks",
        "Compliance Made Simple"
      ],
      icon: "Shield"
    },
    {
      id: 2,
      title: "DevOps & Infrastructure",
      description: "Build it right, scale it smart. We engineer cloud infrastructure that grows with you—no surprises, just smooth sailing.",
      features: [
        "Cloud Architecture That Scales",
        "Automated DevOps Pipelines",
        "Infrastructure as Code",
        "Real-time Health Monitoring"
      ],
      icon: "Server"
    },
    {
      id: 3,
      title: "AI & Automation",
      description: "Let AI do the heavy lifting. We build custom tools and smart automation that make your team more productive, not more stressed.",
      features: [
        "Custom AI Solutions",
        "Workflow Automation",
        "Smart Analytics & Insights",
        "Internal Tool Development"
      ],
      icon: "Cpu"
    },
    {
      id: 4,
      title: "Fractional CTO Services",
      description: "Strategic technology leadership without the full-time cost. We guide your tech decisions, architecture, and team—when you need it, how you need it.",
      features: [
        "Technology Strategy & Roadmapping",
        "Architecture & Infrastructure Planning",
        "Team Leadership & Mentoring",
        "Vendor & Technology Selection"
      ],
      icon: "Settings"
    },
    {
      id: 5,
      title: "Compliance & Integration",
      description: "Compliance doesn't have to be complicated. We handle the checkboxes and connect your systems so everything just works.",
      features: [
        "SOC 2 & ISO 27001 Support",
        "Seamless API Integration",
        "Third-Party Connections",
        "Automated Compliance Checks"
      ],
      icon: "FileCheck"
    }
  ],
  
  team: [
    {
      id: 1,
      name: "Jim Bukowski",
      role: "Chief Technology Officer",
      bio: "15+ years in cloud security, compliance, and infrastructure architecture",
      initials: "JB"
    },
    {
      id: 2,
      name: "Sarah Mitchell",
      role: "Lead Infrastructure Engineer",
      bio: "Expert in cloud architecture and DevOps",
      initials: "SM"
    },
    {
      id: 3,
      name: "Jennifer Chen",
      role: "Compliance Director",
      bio: "Specializes in regulatory frameworks",
      initials: "JC"
    },
    {
      id: 4,
      name: "David Thompson",
      role: "Senior Security Architect",
      bio: "Cloud security and threat intelligence",
      initials: "DT"
    }
  ],
  
  stats: [
    { label: "Veteran Owned & Operated", value: "🇺🇸" },
    { label: "Distributed Team", value: "100%" },
    { label: "Clients Secured", value: "150+" },
    { label: "Uptime Guarantee", value: "99.9%" }
  ],
  
  contact: {
    email: "hello@westbay.io",
    phone: "656-210-9486",
    address: "3730 Midtown Dr #1638",
    city: "Tampa, FL 33607",
    tagline: "Serving clients worldwide | USA Based"
  }
};